import { useSyncExternalStore } from 'react'

// Reads a CSS media query from JS.
//
// Needed where a layout decision can't be expressed in CSS alone — the position
// grid renders a *subset* of weeks on a phone, which is a data decision, not a
// styling one. Anything that can be done with a Tailwind breakpoint should be.
//
// useSyncExternalStore rather than useState+useEffect so the first paint already
// has the right answer instead of flashing the desktop layout.
export function useMediaQuery(query) {
  return useSyncExternalStore(
    (callback) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {}

      const list = window.matchMedia(query)
      list.addEventListener('change', callback)
      return () => list.removeEventListener('change', callback)
    },
    () => (typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(query).matches
      : false),
    () => false
  )
}

// Matches Tailwind's `md` breakpoint, so JS and CSS agree on where "mobile" ends.
export function useIsCompact() {
  return !useMediaQuery('(min-width: 768px)')
}
